import { createFileRoute, redirect } from "@tanstack/react-router";
import { pageHead } from "../lib/utils";
import { requireActive } from "../lib/require-active";

export const Route = createFileRoute("/team-manager")({
  head: () => pageHead("page.teamManager"),
  beforeLoad: ({ context }) => {
    if (context.isPending) return;
    requireActive(context);
    if (!context.auth?.isManager) {
      throw redirect({ to: "/" });
    }
  },
});
